import { atom } from 'recoil';

type NotificationState = {
  isOpen: boolean;
};

/**
 * 알림 state
 */
export const notificationState = atom<NotificationState>({
  key: 'notificationState',
  default: {
    isOpen: false,
  },
});
